import Vue from 'vue'
import { isNull } from 'lodash'
import { detectedCulture } from '@/utilities/common/culture'

const state = () => ({
  subscriptions: [],
  subscriptionDetails: {}
})

const mutations = {
  setSubscriptions (state, subscriptions) {
    state.subscriptions = subscriptions
  },

  setSubscriptionDetails (state, subscriptionDetails) {
    state.subscriptionDetails = subscriptionDetails
  }
}

const actions = {
  async fecthSubscriptions ({ commit }) {
    const subscriptions = await Vue.api.subscription.getSubscriptionAll()
    const normalizedSubscriptions = await Promise.all(subscriptions.map(async subscription => {
      if (subscription.subscriptionNumber) {
        let returnInfo = {}
        await Vue.api.subscription.getReturnInfo(subscription.subscriptionNumber).then(res => {
          returnInfo = res
        })
        return {
          ...subscription,
          tryBuyReturnInfo: returnInfo.tryBuyReturnInfo,
          replenishmentReturnInfo: returnInfo.replenishmentReturnInfo
        }
      } else {
        return subscription
      }
    }))

    commit('setSubscriptions', normalizedSubscriptions)
  },

  async fetchSubscriptionDetails ({ commit }, subscriptionNumber) {
    let subscriptionDetails, returnInfoDetails, replenishmentDetails
    subscriptionDetails = await Vue.api.subscription.getSubscriptionDetailsById(subscriptionNumber)
    returnInfoDetails = Vue.api.subscription.getReturnDetailsBySubscriptionNumber(subscriptionNumber)
    replenishmentDetails = Vue.api.subscription.getReplenishmentsDetails(subscriptionNumber)

    await Promise.all([subscriptionDetails, returnInfoDetails, replenishmentDetails]).then((values) => {
      const subscriptionDetails = values[0]
      const returnInfoDetails = values[1]
      const replenishmentDetails = values[2].data
      replenishmentDetails
        .availableFrequenciesToChange
        .forEach(item => {
          item.billingPeriodLabel = (isNull(item.specificBillingPeriod) ? '' : `${item.specificBillingPeriod + ' '}`) + Vue.prototype.$t(`subscription_details.replenishment.frequency.type.${item.billingPeriod}`, `${item.billingPeriod}`)
        })
      const normalizedSubscriptionDetails = {
        ...subscriptionDetails,
        returnInfoDetails,
        ...replenishmentDetails
      }
      commit('setSubscriptionDetails', normalizedSubscriptionDetails)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
